import $ from 'jquery';
import { getRequestVerificationToken } from './ajax-helpers';

/**
 * Validate Zip Code - Synchronous call
 * @param {String | Number} zipCode - Zipcode
 * @param {String} countryCode - Country Code
 * @returns {Object} response The response object
 * @returns {Boolean} response.isValid Validity of the zip code
 * @returns {Boolean} response.prefillCity Is there an associated city name?
 * @returns {Promise} response.city The associated city name
 */
export const validateZipCode = (zipCode, countryCode) => {

    const promise = new Promise((resolve) => {

        const params = {
            url: '/Cart/ValidateZipCode',
            type: 'POST',
            data: {
                zipCode,
                countryCode
            },
            headers: {
                ...getRequestVerificationToken
            }
        };

        const response = {
            isValid: false,
            prefillCity: false,
            city: ''
        };

        $.ajax(params)
            .done((res) => {
                if (res.IsSuccess) {
                    response.isValid = res.IsValid;
                    response.prefillCity = res.PrefillCity;
                    response.city = res.City;

                    resolve(response);
                    return;
                }

                console.error(`Error validating zipcode: ${res.CountryCode} ${res.ZipCode}. Error message: ${res.ErrorMessage}`);

                response.isValid = false;

                resolve(response);
            })
            .fail((error) => {
                console.error(`${error.status} - ${error.statusText}`);
                response.isValid = false;
                resolve(response);
            });
    });

    return promise;
};
